<template>
    <section class="content">
        <div class="container-fluid">
            <div class="block-header">
                <h2>{{ nama }}</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                {{ id_informasi_kegiatan != null ? 'Edit' : 'Tambah' }} {{ nama }}
                            </h2>
                        </div>
                        <div class="body">
                            <form class="form-horizontal" v-on:submit.prevent="onSubmit">
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="judul">Judul</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line id="judul" type="text" v-model="content.judul"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="tanggal">Tanggal</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <flat-pickr class="form-control" id="tanggal" v-model="tanggal" :config="date"></flat-pickr>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="deskripsi">Deskripsi</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <Ckeditor id="deskripsi" v-model="content.deskripsi" :config="config"></Ckeditor>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix" v-if="id_informasi_kegiatan">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="deskripsi">Foto Kegiatan</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <vue-dropzone ref="myVueDropzone" id="dropzone" :destroyDropzone="false" :options="dropzoneOptions" @vdropzone-removed-file="vremoved" v-on:vdropzone-sending="sendingEvent"></vue-dropzone>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                        <button v-if="id_informasi_kegiatan != null" @click="update" type="button" class="btn btn-warning waves-effect waves-button" v-bind:disabled="isLoading" v-waves.button><i v-if="isLoading" class="fa fa-spin fa-spinner"></i><i v-if="!isLoading" class="material-icons">save</i> Edit</button>
                                        <button v-else @click="save" type="button" class="btn btn-primary waves-effect waves-button" v-bind:disabled="isLoading" v-waves.button><i v-if="isLoading" class="fa fa-spin fa-spinner"></i><i v-if="!isLoading" class="material-icons">save</i> Simpan</button>
                                        <button @click="$router.go(-1)" type="button" class="btn btn-danger" v-waves.button><i class="material-icons">cancel</i> Batal</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import Ckeditor from 'vue-ckeditor2'
  import FormLine from '@/components/FormLine.vue'
  import api from '@/helper/api'
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.css'

  export default {
    components: {FormLine, Ckeditor, vueDropzone: vue2Dropzone},
    name: 'ListNarasumber',
    data: function () {
      return {
        dropzoneOptions: {
          url: api.defaults.baseURL + '/upload_file',
          thumbnailWidth: 150,
          addRemoveLinks: true,
          maxFilesize: 2,
          dictRemoveFileConfirmation: 'Anda yakin ingin menghapus file ini?',
          headers: { 'Authorization': 'Bearer ' + localStorage.getItem('_token') }
        },
        date: {
          dateFormat: 'd-m-Y',
          allowInput: true
        },
        config: {
          toolbar: [
            { name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
            { name: 'morestuff', items: ['NumberedList', 'BulletedList'] },

            { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] },
            { name: 'colors', items: ['TextColor'] },
            { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] },
            '/',
            { name: 'document', items: ['Source'] }
          ],
          height: 300
        },
        content: {
          judul: '',
          deskripsi: '',
          tanggal: ''
        },
        tanggal: '',
        file: '',
        id_informasi_kegiatan: '',
        nama: '',
        tipe: '',
        link: '',
        isLoading: false,
        init: false
      }
    },
    methods: {
      save () {
        this.isLoading = true
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.post('/informasi_kegiatan', this.content).then((result) => {
          if (result.data.code === 200) {
            this.$toastr.s('Tambah data berhasil')
            this.$router.replace('/main/informasi/kegiatan/edit/' + result.data.object.id_informasi_kegiatan)
            location.reload()
          } else {
            var msg = 'Tambah data gagal'
            if (result.data.message !== '') msg = result.data.message
            this.$toastr.e(msg)
          }
          this.isLoading = false
        }).catch(e => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
      },
      update () {
        this.isLoading = true
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.post('/informasi_kegiatan/' + this.id_informasi_kegiatan, this.content).then((result) => {
          if (result.data.code === 200) {
            this.$router.replace('/main/informasi/' + this.link)
            this.$toastr.s('Ubah data berhasil')
          }
          this.isLoading = false
        }).catch(e => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
      },
      getDetail () {
        this.init = true
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.get('/informasi_kegiatan/edit/' + this.id_informasi_kegiatan).then((result) => {
          this.content = result.data
          for (var i = 0; i < this.content.file.length; i++) {
            this.$refs.myVueDropzone.manuallyAddFile({ name: 'Foto', id: this.content.file[i].id_file }, this.content.file[i].file)
          }
          this.tanggal = this.$moment(this.content.tanggal, 'YYYY-MM-DD').format('DD-MM-YYYY')
          this.init = false
        }).catch((ex) => {
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
          this.init = false
        })
      },
      sendingEvent (file, xhr, formData) {
        console.log(this.id_informasi_kegiatan)
        formData.append('id_informasi_kegiatan', parseInt(this.id_informasi_kegiatan))
      },
      onSubmit () {
        if (this.id_informasi_kegiatan != null) this.update()
        else this.save()
      },
      checkRoute (route) {
        console.log(route.name)
        if (route.name === 'TambahKegiatan' || route.name === 'EditKegiatan') {
          this.link = 'kegiatan'
          this.nama = 'Informasi Kegiatan'
        }
      },
      vremoved (file, xhr, error) {
        console.log(file)
        if (!this.init) this.delete(file.id)
      },
      delete (id) {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.delete('/informasi_kegiatan/delete/' + id).then((result) => {
          this.$toastr.s('Foto berhasil dihapus')
          this.getData()
          this.$swal.close()
        }).catch(e => {
          this.getData()
          this.$swal.close()
        })
      }
    },
    mounted () {
      this.checkRoute(this.$route)
      this.id_informasi_kegiatan = this.$route.params.id
      if (this.id_informasi_kegiatan != null) {
        this.getDetail()
      }
    },
    watch: {
      '$route' (to, from) {
        this.checkRoute(to)
        this.getData()
      },
      tanggal: function (val) {
        this.content.tanggal = this.$moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/view/Informasi/Kegiatan/FormKegiatan.vue